import { deviceLocal } from '@/privacy/deviceStorage';

/**
 * T-1144: whether a passkey signed in on this device, so the sign-in page offers it first. It names
 * nobody and proves nothing: the ceremony still decides, and a wrong answer only reorders two buttons.
 */
const KEY = 'featit.passkeyUsedHere';

export function rememberPasskeyUsedHere(): void {
  deviceLocal.setItem(KEY, '1');
}

export function passkeyUsedHere(): boolean {
  return deviceLocal.getItem(KEY) === '1';
}
